/**
 * Tags an outbound link (a store listing, an app's or developer's website) so
 * the destination's analytics attribute the visit to this site.
 */
export const addTrackingParams = (url: string) => {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.set('utm_source', 'webcatalog.io');
  parsedUrl.searchParams.set('utm_medium', 'website');
  return parsedUrl.toString();
};
